import React, { useState } from "react";
import { NavLink, Link } from "react-router-dom";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "./header.css";

import { FaWhatsapp, FaQuestionCircle, FaFileDownload } from "react-icons/fa";

const Header = () => {


  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  const whatsappNumber = "919662917174";

  return (
    <header className="header-area sticky-header">
      {/* Top Bar - Hidden on mobile via d-none d-lg-block */}

      <div className="header-top-bar d-none d-lg-block">
        <div className="container-fluid custom-container">
          <div className="top-bar-content">
            {/* Contact section */}
            <div className="top-right-section">
              <div className="top-contact-info">
                <a
                  className="contact-link"
                  href="tel: 9824595370"
                  title="Call us"
                >
                  <i className="fas fa-phone-alt"></i>
                  <span> +91 9824595370</span>
                </a>

                <a
                  className="contact-link"
                  href="mailto:sales@sachiproducts.com"
                  title="Email us"
                >
                  <i className="fas fa-envelope"></i>
                  <span>sales@sachiproducts.com</span>
                </a>
              </div>
            </div>

            {/* Social icons */}
            <div className="top-social-icons">
              {/* Use <a> tags for external websites */}
              <a
                href="https://www.facebook.com/sachiproducts1996"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fab fa-facebook-f"></i>
              </a>

              <a
                href="https://www.instagram.com/sachiproducts1996/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fab fa-instagram"></i>
              </a>

              <a
                href="https://www.youtube.com/@SACHIPRODUCTS"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fab fa-youtube"></i>
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Main Nav Area */}
      <div className="main-header-nav">
        <div className="container-fluid custom-container">
          <div className="header-align">
            <div className="header-logo">
              <Link to="/">
                <img src="/assets/img/sachi_logo.png" alt="Sachi Products" />
              </Link>
            </div>

            {/* THE FIX: This nav must have the "open" class based on state */}
            <nav className={`nav-menus-wrapper ${isMenuOpen ? "open" : ""}`}>
              {/* Close Button inside the mobile sidebar */}
              {/* <div
                className="mobile-menu-close d-lg-none"
                onClick={toggleMenu}
                style={{
                  position: "absolute",
                  top: "20px",
                  right: "20px",
                  fontSize: "24px",
                  cursor: "pointer",
                }}
              >
                <i className="fas fa-times"></i>
              </div> */}

              <ul className="main-menu">
                <li>
                  <NavLink to="/" onClick={() => setIsMenuOpen(false)}>
                    Home
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/about" onClick={() => setIsMenuOpen(false)}>
                    About
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/product" onClick={() => setIsMenuOpen(false)}>
                    Categories
                  </NavLink>
                </li>

                <li>
                  <NavLink to="/inquiry" onClick={() => setIsMenuOpen(false)}>
                    Inquiry
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/contact_us"
                    onClick={() => setIsMenuOpen(false)}
                  >
                    Contact
                  </NavLink>
                </li>
                {/* <li className="mobile-only">
                  <NavLink to="#" onClick={() => setIsMenuOpen(false)}>
                    New Arrival
                  </NavLink>
                </li> */}
              </ul>
            </nav>
          </div>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "19px",
            padding: "10px 0",
          }}
        >
          {/* WhatsApp */}
          {/* <div style={{ textAlign: "center" }}>
            <a href={`https://wa.me/${whatsappNumber}?text=Hello! I'm interested in your products`}
              target="_blank"
              rel="noopener noreferrer"
              // className="sticky-btn whatsapp-sticky"
              title="Chat on WhatsApp">
              <i
                className="fab fa-whatsapp"
                style={{ color: "green", fontSize: "26px" }}
              ></i>
            </a>
            <div style={{ fontSize: "14px", marginTop: "4px", fontWeight: "700", textTransform: "capitalize" }}>WhatsApp</div>
          </div>

          {/* Help *
          <div style={{ textAlign: "center" }}>
            <a href="/contact_us">
              <i
                className="fa fa-question-circle"
                style={{ color: "red", fontSize: "26px" }}
              ></i>
            </a>
            <div style={{ fontSize: "14px", marginTop: "4px", fontWeight: "700", textTransform: "capitalize" }}>Help</div>
          </div> */}

          {/* Catalogue */}
          <div style={{ textAlign: "center" }}>
            <a
              href="/assets/pdf/catelogue.pdf"
              download
              title="Download Brochure"
            >
              <i
                className="fa-solid fa-file-pdf"
                style={{ color: "#245e85", fontSize: "26px" }}
              ></i>
            </a>
            <div style={{ fontSize: "14px", marginTop: "4px", fontWeight: "700", textTransform: "capitalize", marginRight: "15px" }}>
              Catalogue
            </div>
          </div>
        </div>

        <div className="header-actions">
          {/* Hamburger Toggle */}
          <div className="mobile-toggle d-lg-none" onClick={toggleMenu}>
            <i className="fas fa-bars"></i>
          </div>
        </div>
      </div>

      {/* Dark Overlay - Critical for mobile UX */}
      <div
        className={`menu-overlay ${isMenuOpen ? "active" : ""}`}
        onClick={toggleMenu}
      ></div>
    </header>
  );
};

export default Header;
